import { Autocomplete, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormHelperText, Grid, TextField, Tooltip, Typography, createFilterOptions } from '@mui/material';
import { findIndex } from "lodash";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { LoadOrganizations, LoadPlans } from '../../actions';
import { countries } from '../../helpers/countries';
import { setHeaderTitle } from '../../helpers/header.helper';
import setToast from '../../helpers/toaster.helper';
import { CancelIcon, DoneDarkIcon } from '../../icon';
import { ProductType } from '../../models/add-phone-number.model';
import { mapToFeature } from '../../models/features.model';
import { OrganizationModel } from '../../models/organization.model';
import { PlanModel, PlanType } from '../../models/plans.model';
import * as selector from '../../selectors/selectors';
import { FeatureService } from '../../services/FeatureService';
import { PlansService } from '../../services/plans.service';
import { AppRoutes } from '../routes/route.path';
import ButtonComponent from '../shared/button/button.component';
import { ToasterTexts, buttonLabels } from '../shared/constants';
import { ToasterType } from '../shared/toaster/toaster.model';
import { useNavigate } from 'react-router-dom'

const Privacy = [{ Name: "False", Value: false }, { Name: "True", Value: true }]
const products =
    [{ Name: "Landline Texting", Value: ProductType.LANDLINE_TEXTING },
    { Name: "VoIP Texting", Value: ProductType.VOIP_TEXTING },
    { Name: "MS Teams Calling and Texting", Value: ProductType.MS_TEAMS_TEXTING },
    { Name: "Toll-Free Texting", Value: ProductType.TOLL_FREE_TEXTING }];

const dashboards = [{ Name: "No Dashboard", Value: 0 }, { Name: "Basic", Value: 1 }, { Name: "Standard", Value: 2 }, { Name: "Corporate", Value: 3 }];

const graceperiod = [{ Name: "No Grace Period", Value: 0 }, { Name: "30 Days", Value: 1 }, { Name: "60 Days", Value: 2 }, { Name: "90 Days", Value: 3 }]


interface allFeatures {
    ID: string; Name: string; Label: string; Type: number; IsDeleted: boolean; CreatedDateTime: string; DisplayOrder: number; Code: string; SelectedFeature: boolean; Validity: boolean; Value: string; SelectedFeatureError: string
}
interface errorModal {
    PlanName: string, FootNote: string, GracePeriod: string, DashBoard: string, ProductType: string, Country: string, MonthlyPrice: string, YearlyPrice: string, IsPrivate: string, SelectedOrganizations: string
}

interface Iprops { }

const ViewTier = (props: Iprops) => {

    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const Organizations: OrganizationModel[] = useSelector(selector.organizations)
    const Plans: PlanModel[] = useSelector(selector.plans).filter(x => x.Type === PlanType.TIER)
    const LoadedPlans: boolean = useSelector(selector.loadedPlans)

    const Autofilter = createFilterOptions();
    const [allFeature, setAllFeature] = useState<allFeatures[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [planid, setPlanID] = useState<string>("")
    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [name, setName] = useState<string>("")
    const [footNote, setFootNote] = useState<string>("")
    const [gracePeriod, setGracePeriod] = useState<number>(-1)
    const [dashboard, setDashBoard] = useState<number>(-1)
    const [productType, setProductType] = useState<number>(-1)
    const [country, setCountry] = useState<string>("")
    const [monthlyPrice, setMonthlyPrice] = useState<string>("")
    const [yearlyPrice, setYearlyPrice] = useState<string>("")
    const [isPrivate, setIsPrivate] = useState<boolean | -1>(-1)
    const [selectedOrganizations, setSelectedOrganizations] = useState<string[]>([])
    const [selectAll, setSelectAll] = useState<boolean>(false)
    const [buttonLable, setButtonLable] = useState<string>("Add Plan")
    const [showConfirm, setShowConfirm] = useState<boolean>(false)
    const [error, setError] = useState<errorModal>({ PlanName: "", FootNote: "", GracePeriod: "", DashBoard: "", ProductType: "", Country: "", MonthlyPrice: "", YearlyPrice: "", IsPrivate: "", SelectedOrganizations: "" })

    useEffect(() => {
        if (Plans?.length < 1) {
            LoadPlans(dispatch)
        }
        if (Organizations?.length < 1) {
            LoadOrganizations(dispatch)
        }
    }, [])

    useEffect(() => {
        if (LoadedPlans) {
            FeatureService.getAllFeature().then((res) => {
                let allfeatureData = res.data.map(mapToFeature)
                const planID = params?.PlanID

                allfeatureData = allfeatureData.map(item => ({ ...item, SelectedFeature: false, Validity: false, Value: "", SelectedFeatureError: "" }))
                if (planID === "addPlan") {
                    setAllFeature(allfeatureData)
                    setHeaderTitle("Add Plan")
                }
                else {
                    setHeaderTitle(planID.includes("duplicate") ? "Duplicate Plan" : "Edit Plan")
                    setButtonLable(planID.includes("duplicate") ? buttonLabels.DUPLICATE_TIER : buttonLabels.UPDATE_TIER)
                    setIsEdit(planID.includes("duplicate") ? false : true)
                    setPlanID(planID.replace('duplicate', ''))
                    let filterPlan: PlanModel = Plans.find(x => x.PlanID === planID.replace('duplicate', ''))
                    let filterdata = allfeatureData?.map(item => {
                        let plan = filterPlan?.Features?.find(x => x.ID === item.ID)
                        if (plan) {
                            item.SelectedFeature = true
                            return { ...item, ...plan }
                        }
                        return item
                    })

                    const updatedFeatureArray = filterdata?.map(item => {
                        if (item?.SelectedFeature) {
                            item.Validity = item.Value === "-1" ? true : false;
                            item.Value = item.Value !== "-1" ? item?.Value : null;
                        }

                        return item;
                    });
                    setSelectAll(updatedFeatureArray.filter(x => x.Type === 1)?.length === updatedFeatureArray.filter(x => x.Type === 1).filter(item => item.SelectedFeature === true)?.length)
                    setAllFeature(updatedFeatureArray)
                    setName(filterPlan.Name)
                    setFootNote(filterPlan.Footnote)
                    setProductType(filterPlan.Product)
                    setCountry(filterPlan.Country)
                    setGracePeriod(filterPlan.GracePeriod)
                    setDashBoard(filterPlan.Dashboard)
                    setMonthlyPrice(String(filterPlan.Price))
                    setYearlyPrice(String(filterPlan.YearlyPrice))
                    setIsPrivate(filterPlan.IsPrivate)
                    setSelectedOrganizations(filterPlan.SelectedOrganizations)
                }
            }).catch((err) => {

            })
        }

        return setHeaderTitle()

    }, [params?.PlanID, LoadedPlans])

    const handlePlanName = (value) => {        
        const isWhitespace = value.length >= 0 && !value.trim()
        setError({ ...error, PlanName: value.length > 30 ? "Plan Name should not exceed 30 characters" : isWhitespace ? "Required*" : "" })
        setName(value)
    }
    const handleNotes = (e) => {
        setFootNote(e.target.value)
        if (e.target.value.length > 30) {
            setError({ ...error, FootNote: "Footnote should not exceed 30 characters" })
        }
        else {
            setError({ ...error, FootNote: "" })
        }
    }

    const handleGracePeriod = (e: any, value: any) => {
        if (value) {
            setGracePeriod(value?.Value)
            setError({ ...error, GracePeriod: "" })

        }
        else {
            setError({ ...error, GracePeriod: "Required*" })
            setGracePeriod(-1)
        }
    }

    const handleDashboard = (e: any, value: any) => {
        if (value) {
            setDashBoard(value?.Value)
            setError({ ...error, DashBoard: "" })
        }
        else {
            setError({ ...error, DashBoard: "Required*" })
            setDashBoard(-1)
        }
    }

    const handleProductChange = (e: any, value: any) => {
        if (value) {
            setProductType(value?.Value)
            setError({ ...error, ProductType: "" })
        }
        else {
            setError({ ...error, ProductType: "Required*" })
            setProductType(-1)
        }
    }

    const handleCountryChange = (e: any, value: any) => {
        if (value) {
            setError({ ...error, Country: "" })
            setCountry(value.ISO)
        }
        else {
            setError({ ...error, Country: "Required*" })
            setCountry("")

        }
    }

    const handlePrivacyChange = (e: any, value: any) => {
        if (value?.Name === 'False') {
            setIsPrivate(value?.Value)
            setSelectedOrganizations([])
            setError({ ...error, SelectedOrganizations: "" })
        }
        else {
            setIsPrivate(value?.Value)
            setError({ ...error, SelectedOrganizations: "" })
        }
    }

    const getOrganizations = () => {
        return Organizations.filter(x => !x.IsDeleted)
    }

    const handleCheckBox = (event: any, values: any) => {
        let val = values.map(x => findIndex(x.ID))
        if (val.find(x => x === -1)) {
            if (getOrganizations().length === selectedOrganizations.length) {
                setSelectedOrganizations([])
                setIsPrivate(true)
            }
            else {
                setSelectedOrganizations(getOrganizations().map(x => x.ID))
            }
        }
        else {
            setSelectedOrganizations(values.map(x => x.ID))
        }
        if (values.length === 0) {
            setIsPrivate(true)
            setError({ ...error, SelectedOrganizations: "Required*" })
        }
        if (values.length !== 0) {
            setIsPrivate(true)
            setError({ ...error, SelectedOrganizations: "" })
        }
    };

    const optionRenderer = (defaultprops, option: any, { selected }: any) => {
        const selectAllProps =
            selectedOrganizations.length > 0 && option.value === -1
                ? { checked: (getOrganizations().length === selectedOrganizations.length) }
                : {};

        return (
            <li {...defaultprops}>
                <Checkbox
                    name="checkbox"
                    className="mr-1"
                    classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                    indeterminate={option.value === -1 && getOrganizations().length - 1 === selectedOrganizations.length}
                    checked={selected}
                    {...selectAllProps}
                />
                <div className={`my-auto t-align-left`}> {option?.Name} </div>
            </li >
        )
    }

    const handleSelectfeature = (id: string, checked: boolean) => {
        const selectedFeatures = allFeature.map(x => x.ID === id ? { ...x, SelectedFeature: checked, Validity: false, Value: "", SelectedFeatureError: checked ? "Please select Unlimited or enter a value." : "" } : x)
        setAllFeature(selectedFeatures)
    }

    const handleUnlimited = (id: string, checked: boolean) => {
        const selectedFeatures = allFeature.map(x => x.ID === id ? { ...x, Validity: checked, Value: "", SelectedFeatureError: checked ? "" : "Please select Unlimited or enter a value." } : x)
        setAllFeature(selectedFeatures)
    }

    const handleFeatureValue = (id: string, e) => {
        const regex = /^[0-9]*$/;
        if (!regex.test(e.target.value)) {
            e.target.value = e.target.value.replace(/[^0-9]/g, '');
        }
        const selectedFeatures = allFeature.map(x => x.ID === id ? { ...x, Value: e.target.value, Validity: false, SelectedFeatureError: Number(e.target.value) ? "" : "Please select Unlimited or enter a value." } : x)
        setAllFeature(selectedFeatures)
    }

    const handleAdditionalFeature = (id: string, checked: boolean) => {
        const selectedFeatures = allFeature.map(x => x.ID === id ? { ...x, SelectedFeature: checked } : x)
        if (!checked) {
            setSelectAll(false)
        }
        else {
            if (!selectedFeatures.find(x => x.Type === 1 && !x.SelectedFeature)) {
                setSelectAll(true)
            }
        }
        setAllFeature(selectedFeatures)
    }

    const handleSelectAll = (checked: boolean) => {
        const selectedFeatures = allFeature.map(x => x.Type === 1 ? { ...x, SelectedFeature: checked } : x)
        setAllFeature(selectedFeatures)
        setSelectAll(checked)
    }

    const openConfirm = () => {
        setShowConfirm(true)
    }

    const closePlan = () => {
        navigate(AppRoutes.TIERS)
    }

    const handleMontlyPrice = (e) => {
        const value = e.target.value;
        const isValidPrice = /^\d{0,5}(\.\d{0,2})?$/.test(value);
        if (isValidPrice || value === '') {
            setError({ ...error, MonthlyPrice: value.length === 0 ? "Required*" : '' });
            setMonthlyPrice(value);
        }
    }

    const handleKeyPress = (e) => {
        if (e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+') {
            e.preventDefault();
        }
    }

    const handleYearlyPrice = (e) => {
        const value = e.target.value;
        const isValidPrice = /^\d{0,5}(\.\d{0,2})?$/.test(value);
        if (isValidPrice || value === '') {
            setError({ ...error, YearlyPrice: value.length === 0 ? "Required*" : '' });
            setYearlyPrice(value)
        }
    }

    const isValid = () => {
        const OrgSelected = (isPrivate === true && selectedOrganizations.length > 0 || isPrivate === false && selectedOrganizations.length === 0);
        let flag = !!name && gracePeriod !== -1 && dashboard !== -1 && productType !== -1 && !!country && !!monthlyPrice && !!yearlyPrice && isPrivate !== -1 && OrgSelected &&
            allFeature.filter(x => x.Type === 0 && x.SelectedFeature === true)?.length !== 0;
        flag = Object.values(error).every(value => value === "") && allFeature.every(obj => obj.SelectedFeatureError === "") && flag
        return flag
    }

    const createPlan = () => {
        setIsLoading(true)
        const obj = allFeature.filter(x => x.SelectedFeature).map(x => { return { code: x.Code, featureType: x.Type, label: x.Label, value: !!x.Value ? String(x.Value) : "-1", id: x.ID } })
        const data = {
            id: isEdit ? planid : undefined,
            name: name?.trim(),
            planType: 1,
            price: Number(monthlyPrice),
            yPrice: Number(yearlyPrice),
            features: obj,
            color: "#000",
            fNotes: footNote?.trim(),
            isDeleted: true, //need to check
            dashboardType: dashboard,
            gracePeriod: gracePeriod,
            productType: productType,
            // occurrenceType: this.state.TierOccurrence,
            isPrivate: isPrivate,
            organizationId: selectedOrganizations,
            country: country
        }
        if (isEdit) {
            PlansService.updatePlans(data).then(() => {
                setIsLoading(false)
                LoadPlans(dispatch);
                setToast(ToasterTexts.TIER_EDIT_SUCCESS.replace('<Name>', data.name), ToasterType.SUCCESS)
                closePlan()
                setIsLoading(false)
                setShowConfirm(false)

            }).catch(err => {
                setToast(err.response.data.message, ToasterType.DANGER)
                setIsLoading(false)
                setShowConfirm(false)
            }
            )
        }
        else {
            PlansService.createPlans(data).then(() => {
                setIsLoading(false)
                LoadPlans(dispatch);
                setToast(ToasterTexts.TIER_ADD_SUCCESS.replace('<Name>', name), ToasterType.SUCCESS)
                closePlan();
            }).catch(err => {
                setIsLoading(false)
                setToast(err.response.data.message, ToasterType.DANGER)
            })
        }
    }

    const closeConfirm = () => {
        setShowConfirm(false)
    }

    return (
        <div className='mx-2'>
            <div className='h-v-80 p-1 o-y-scroll'>
                <Grid container>
                    <Grid item md={6} xs={12}>
                        <TextField
                            label="Plan Name *"
                            variant="outlined"
                            name="name"
                            size='small'
                            value={name}
                            disabled={isEdit}
                            onChange={(e) => handlePlanName(e.target.value)}
                            InputProps={{
                                classes: { input: `${'h4-regular'} color-text-field-font` },
                                style: {
                                    backgroundColor: isEdit ? 'lightgrey' : 'transparent',
                                }
                            }}
                            className="mx-1 my-1 w-fill" />
                        <FormHelperText className={`h5-regular color-primary-danger t-align-right mr-1`}>
                            {error.PlanName}
                        </FormHelperText>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <TextField
                            label="Footnote"
                            variant="outlined"
                            size='small'
                            name="footNote"
                            value={footNote}
                            onChange={handleNotes}
                            InputProps={{ classes: { input: `h4-regular color-text-field-font` } }}
                            className="mx-1 my-1 w-fill" />
                        <FormHelperText className="h5 color-primary-danger t-align-right">
                            {error.FootNote}
                        </FormHelperText>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <Autocomplete
                            size="small"
                            className={" mx-1 my-1 w-fill"}
                            classes={{ input: 'h2 color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                            options={products}
                            getOptionLabel={(option: any) => option.Name}
                            onChange={handleProductChange}
                            value={products.find(x => x.Value === productType)
                                || { Name: "", Value: 0 }
                            }
                            renderOption={(defaultprops, option: any) => (
                                <li {...defaultprops}>
                                    <span className={"c-pointer h2 color-primary-dark p-2 d-flex justify-between w-p-90"}>
                                        {option.Name}
                                    </span>
                                </li>
                            )}
                            renderInput={(params) => <TextField {...params} name="product" required variant="outlined" label="Select Product" placeholder="Select Product" />}
                        />
                        <FormHelperText className="h5 color-primary-danger t-align-right">
                            {error.ProductType}
                        </FormHelperText>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <Autocomplete
                            size="small"
                            className={"w-fill my-1 mx-1"}
                            classes={{ input: 'h2 color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                            options={countries}
                            getOptionLabel={(option: any) => option.Name}
                            onChange={handleCountryChange}
                            value={countries.find(x => x.ISO === country) || { ISO: "", Name: "" }}
                            renderOption={(defaultprops, option: any) => (
                                <li {...defaultprops}>
                                    <span className={"c-pointer h2 color-primary-dark p-2 d-flex justify-between w-p-90"}>
                                        {option.Name}
                                    </span>
                                </li>
                            )}
                            renderInput={(params) => {
                                return (<TextField {...params} name="country" required variant="outlined" label="Select Country" placeholder="Select Country" inputProps={{ ...params.inputProps, autoComplete: 'new-password' }} />)
                            }}
                        />
                        <FormHelperText className="h5 color-primary-danger t-align-right">
                            {error.Country}
                        </FormHelperText>
                    </Grid>
                    <Grid item md={6} xs={6}>
                        <Autocomplete
                            size="small"
                            className={"mx-1 my-1 w-fill"}
                            classes={{
                                input: `h4-regular color-text-field-font`,
                                paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow'
                            }}
                            options={graceperiod}
                            getOptionLabel={(option: any) => option.Name}
                            onChange={handleGracePeriod}
                            value={graceperiod.find(x => x.Value === gracePeriod)
                                || { Name: "", Value: -1 }
                            }
                            renderOption={(defaultprops, option: any) => (
                                <li {...defaultprops}>
                                    <span className={`c-pointer h4-regular color-menu-list-font-color p-2 d-flex justify-between w-p-90`}>
                                        {option.Name}
                                    </span>
                                </li>
                            )}
                            renderInput={(params) => <TextField {...params} name="graceperiod" required variant="outlined" label="Select Grace Period" placeholder="Select Grace Period" />}
                        />
                        <FormHelperText className={`h5-regular color-primary-danger t-align-right mr-1`}>
                            {error.GracePeriod}
                        </FormHelperText>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <Autocomplete
                            size="small"
                            className={"w-fill my-1 mx-1"}
                            classes={{ input: 'h2 color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                            options={dashboards}
                            getOptionLabel={(option: any) => option.Name}
                            onChange={handleDashboard}
                            value={dashboards.find(x => x.Value === dashboard)
                                || { Name: "", Value: -1 }
                            }
                            renderOption={(defaultprops, option: any) => (
                                <li {...defaultprops}>
                                    <span className={"c-pointer h2 color-primary-dark p-2 d-flex justify-between w-p-90"}>
                                        {option.Name}
                                    </span>
                                </li>
                            )}
                            renderInput={(params) => <TextField {...params} name="dashboard" required variant="outlined" label="Select Dashboard" placeholder="Select Dashboard" />}
                        />
                        <FormHelperText className={`h5-regular color-primary-danger t-align-right mr-1`}>
                            {error.DashBoard}
                        </FormHelperText>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            type="number"
                            name="Price"
                            value={monthlyPrice}
                            label={"Monthly Price"}
                            variant="outlined"
                            onChange={(e) => handleMontlyPrice(e)}
                            onKeyPress={(e) => handleKeyPress(e)}
                            InputProps={{
                                classes: { input: `h4-regular color-text-field-font` },
                            }}
                            required
                            size="small"
                            fullWidth
                            className="mx-1 w-fill my-1" />
                        <FormHelperText className="h5 color-primary-danger t-align-right">
                            {error.MonthlyPrice}
                        </FormHelperText>
                    </Grid>

                    <Grid item xs={12} md={6} >
                        <TextField
                            type="number"
                            name="YearlyPrice"
                            value={yearlyPrice}
                            label="Annual Price"
                            required
                            variant="outlined"
                            onChange={(e) => handleYearlyPrice(e)}
                            onKeyPress={(e) => handleKeyPress(e)}
                            InputProps={{
                                classes: { input: `h4-regular color-text-field-font` },
                            }}
                            size="small"
                            fullWidth
                            className="mx-1 my-1 w-fill" />
                        <FormHelperText className="h5 color-primary-danger t-align-right">
                            {error.YearlyPrice}
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            size="small"
                            className={"w-fill mx-1 my-1"}
                            classes={{ input: 'h2 color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                            options={Privacy}
                            getOptionLabel={(option: any) => option.Name}
                            onChange={handlePrivacyChange}
                            value={Privacy.find(x => x.Value === isPrivate) || { Name: "", Value: null }}
                            renderOption={(defaultprops, option: any) => (
                                <li {...defaultprops} >
                                    <span className={`c-pointer h2 color-primary-dark p-2 d-flex justify-between w-p-90`}>
                                        {option.Name}
                                    </span>
                                </li>
                            )}
                            renderInput={(params) => <TextField {...params} name="Privacy" required variant="outlined" label="Is Private" placeholder="Public" />}
                            disableClearable={true}
                        />
                        <FormHelperText className="h5 color-primary-danger t-align-right">
                            {error.IsPrivate}
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {
                            isPrivate === true ?
                                <div>
                                    <Autocomplete
                                        ListboxProps={
                                            {
                                                style: {
                                                    maxHeight: '16rem',
                                                }
                                            }
                                        }
                                        multiple
                                        limitTags={2}
                                        size="small"
                                        className={"w-fill mx-1 my-1"}
                                        disableCloseOnSelect={true}
                                        options={getOrganizations()}
                                        getOptionLabel={(option: any) => option.Name}
                                        classes={{ input: 'h2 color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        onChange={handleCheckBox}
                                        value={getOrganizations().filter(x => selectedOrganizations.includes(x.ID))}
                                        filterOptions={(options: any[], params: any) => {
                                            if (getOrganizations().length > 0) {
                                                const filtered = Autofilter(options, params);
                                                return [{ Name: "Select all", value: -1 }, ...filtered];
                                            } else if (getOrganizations().length === 0) {
                                                const filtered = Autofilter(options, params);
                                                return [...filtered];
                                            }
                                            else { return options; }
                                        }}
                                        renderOption={optionRenderer}
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => (
                                                <Chip
                                                    classes={{
                                                        colorPrimary: "custom-color-chip-2",
                                                        avatarColorPrimary: "custom-chip-avatar",
                                                    }}
                                                    color='primary'
                                                    label={option.Name}
                                                    {...getTagProps({ index })}
                                                />
                                            ))
                                        }
                                        renderInput={(params) => <TextField {...params} name="PlanType" required variant="outlined" label="Select Organization" />}
                                    />
                                    <FormHelperText className="h5 color-primary-danger t-align-right">
                                        {error.SelectedOrganizations}
                                    </FormHelperText>
                                </div>
                                : null
                        }

                    </Grid>
                </Grid>
                <div className='mt-2 mx-1'>
                    <label className='h1-regular'>Main Features*</label>
                    {
                        allFeature.filter(x => x.Type === 0).map((item) =>
                            <div>
                                <div className='d-flex justify-between align-center'>
                                    <div className='w-p-20'>
                                        <FormControlLabel
                                            control={<Checkbox
                                                defaultChecked={false}
                                                checked={item.SelectedFeature}
                                                classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                                onChange={(e) => handleSelectfeature(item.ID, e?.target.checked)}
                                            />}
                                            label={item.Name} />
                                    </div>
                                    <div className=''>
                                        <FormControlLabel
                                            control={<Checkbox
                                                defaultChecked={false}
                                                checked={item.Validity}
                                                disabled={!item.SelectedFeature}
                                                classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                                onChange={(e) => handleUnlimited(item.ID, e.target?.checked)}
                                            />} label="Unlimited" />
                                    </div>
                                    <div>
                                        <TextField
                                            type="number"
                                            name="value"
                                            value={item.Value}
                                            disabled={(item.Validity && item.SelectedFeature) || (!item.Validity && !item.SelectedFeature)}
                                            // margin="dense"
                                            label="Value"
                                            variant="outlined"
                                            onChange={(e) => handleFeatureValue(item.ID, e)}
                                            onKeyPress={(e) => handleKeyPress(e)}
                                            autoComplete='no'
                                            size="small"
                                            required
                                            fullWidth
                                            InputProps={{
                                                classes: { input: `h4-regular color-text-field-font` },
                                                style: {
                                                    backgroundColor: ((item.Validity && item.SelectedFeature) || (!item.Validity && !item.SelectedFeature)) ? 'lightgrey' : 'transparent',
                                                }
                                            }}
                                            className="mx-1  w-fill" />

                                    </div>
                                </div>
                                <FormHelperText className="h5 color-primary-danger t-align-right ml-auto mr-1">
                                    {item.SelectedFeatureError}
                                </FormHelperText>
                            </div>
                        )
                    }
                </div>
                <div>
                    <label className='h1-regular mr-5'>Additional Features</label>
                    <div className='mx-2 '>
                        <FormControlLabel
                            control={<Checkbox
                                defaultChecked={false}
                                checked={selectAll}
                                classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                onChange={(e) => handleSelectAll(e?.target.checked)}
                            />}
                            label={"Select All"} />
                    </div>

                    <Grid container>
                        {allFeature.filter(x => x.Type === 1).map(item =>
                            <Grid md={3} className='d-flex mx-2'>
                                <FormControlLabel
                                    control={<Checkbox
                                        defaultChecked={false}
                                        checked={item.SelectedFeature}
                                        classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                        onChange={(e) => handleAdditionalFeature(item.ID, e?.target.checked)}
                                    />}
                                    label={item.Name} />
                            </Grid>
                        )}
                    </Grid>
                </div>
            </div>
            <div className='d-flex mt-2'>
                <ButtonComponent
                    OnClick={() => closePlan()}
                    ButtonLabel={buttonLabels.CANCEL}
                    ClassName={"ml-auto mr-1"}
                    Variant={"secondary-btn-small"} />
                <ButtonComponent
                    Loading={isLoading}
                    ButtonLabel={buttonLable}
                    ClassName={"mr-3 pl-4 pr-4"}
                    Variant={(isValid()) ? "primary-btn-small" : "disabled-btn-small"}
                    OnClick={() => openConfirm()}
                />
            </div>

            <Dialog open={showConfirm} fullWidth={true} maxWidth={"sm"} onClose={() => closeConfirm()}>
                <DialogTitle>
                    <div className='d-flex'>
                        <div>
                            Confirm Plan
                        </div>
                        <Tooltip title='Close' placement='bottom'>
                            <span className="ml-auto">
                                <CancelIcon className={"c-pointer"} onClick={() => closeConfirm()} />
                            </span>
                        </Tooltip>
                    </div>
                </DialogTitle>
                <DialogContent >
                    <div className="d-flex flex-direction justify-between mb-1">
                        <Grid container >
                            <Grid md={6} className={`h2-semibold color-primary-warning`}>
                                <span>{"$" + monthlyPrice}</span>
                                <span className='color-plan-text'>/ Month</span></Grid>
                            <Grid md={6} className={`h2-semibold color-primary-warning`}>
                                <span>{"$" + yearlyPrice}</span>
                                <span className='color-plan-text'>/ Year</span>
                            </Grid>
                        </Grid>
                    </div>
                    <Grid className="h2-bold w-break t-align-left">
                        {name}
                    </Grid>
                    <Grid container>
                        <Grid md={6} className={`h4-regular color-primary`}>{"Footnote"}</Grid>
                        <Grid md={6} className={`h4-semibold color-primary`}>{": " + footNote}</Grid>
                    </Grid>
                    <Grid container>
                        <Grid md={6} className={`h4-regular color-primary`}>{"Product"}</Grid>
                        <Grid md={6} className={`h4-semibold color-primary`}>{": " + products.find(x => x.Value === productType)?.Name}</Grid>
                    </Grid>
                    <Grid container>
                        <Grid md={6} className={`h4-regular color-primary`}>{"Country"}</Grid>
                        <Grid md={6} className={`h4-semibold color-primary`}>{": " + countries.find(x => x.ISO === country)?.Name}</Grid>
                    </Grid>
                    <Grid container >
                        <Grid md={6} className={`h4-regular color-primary`}>{"GracePeriod"}</Grid>
                        <Grid md={6} className={`h4-semibold color-primary `}>{": " + graceperiod.find(x => x.Value === gracePeriod)?.Name}</Grid>
                    </Grid>
                    <Grid container >
                        <Grid md={6} className={`h4-regular color-primary`}>{"DashBoard"}</Grid>
                        <Grid md={6} className={`h4-semibold color-primary `}>{": " + dashboards.find(x => x.Value === dashboard)?.Name}</Grid>
                    </Grid>
                    <Grid container>
                        <Grid md={6} className={`h4-regular color-primary`}>{"Private Plan"}</Grid>
                        <Grid md={6} className={`h4-semibold color-primary `}>{isPrivate ? ": True" : ": False"}</Grid>
                    </Grid>
                    {isPrivate ? <div>
                        <Typography className={`h4-regular w-break color-primary`}>{"Organization List: "}</Typography>
                        {
                            selectedOrganizations.map((org, inx) => {
                                return <Typography className={`h4-semibold w-break color-primary ml-2`} gutterBottom>{inx + 1 + ". "}{Organizations.filter((or) => or.ID == org)[0]?.Name}</Typography>
                            })
                        }
                    </div> : <></>}
                    <div className='h3-bold my-1'>
                        Main Features
                    </div>
                    {allFeature.filter(x => x.Type === 0).map(y =>
                        y.SelectedFeature && <Grid container >
                            <Grid item md={6} className='h4-regular'>
                                {y.Name}
                            </Grid>
                            {y.Validity ?
                                <Grid item md={6} className='h4-semibold color-primary-warning'>
                                    {": Unlimited"}
                                </Grid>
                                :
                                <Grid item md={6} className='h4-semibold color-primary-warning'>
                                    {": " + y.Value}
                                </Grid>
                            }
                        </Grid>
                    )}
                    <div className='h3-bold my-1'>
                        Additional Features
                    </div>
                    <Grid container>
                        {allFeature.filter(x => x.Type === 1).map(y =>
                            y.SelectedFeature &&
                            <Grid md={4} className='d-flex h4-regular align-center'>
                                <DoneDarkIcon className={"mr-1"} />
                                {y.Name}
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <div className='d-flex'>
                        <ButtonComponent
                            OnClick={() => closeConfirm()}
                            ButtonLabel={buttonLabels.CANCEL}
                            ClassName={"ml-auto mr-1"}
                            Variant={"secondary-btn-small"} />
                        <ButtonComponent
                            Loading={isLoading}
                            ButtonLabel={buttonLabels.CONFIRM_PLAN}
                            ClassName={" mr-3 pl-4 pr-4"}
                            Variant={(isValid()) ? "primary-btn-small" : "disabled-btn-small"}
                            OnClick={() => createPlan()}
                        />
                    </div>
                </DialogActions>
            </Dialog>
        </div >
    )
}

export default ViewTier;
